var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAdvancedSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6244 2.89601L14.1682 5.35163H12.4369V3.62026L14.8924 1.1639C14.1337 0.749472 13.2669 0.575721 12.4071 0.665732C11.5473 0.755742 10.7353 1.10525 10.0789 1.66782C9.42248 2.23039 8.95278 2.97939 8.7322 3.81529C8.51162 4.6512 8.55061 5.53444 8.84397 6.34766L1.18494 14.0041C0.840174 14.3489 0.646484 14.8165 0.646484 15.3041C0.646484 15.7917 0.840174 16.2593 1.18494 16.6041C1.52971 16.9489 1.99732 17.1426 2.4849 17.1426C2.97248 17.1426 3.44008 16.9489 3.78485 16.6041L11.4417 8.94398C12.2548 9.23736 13.138 9.27634 13.9739 9.05576C14.8098 8.83517 15.5587 8.36545 16.1213 7.70901C16.6838 7.05257 17.0333 6.24049 17.1233 5.38067C17.2133 4.52085 17.0396 3.65399 16.6252 2.89527L16.6244 2.89601Z",
    stroke: "#4152B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedSettings);
export default __webpack_public_path__ + "static/media/advanced-settings.45a958e9.svg";
export { ForwardRef as ReactComponent };